import { render } from "./stockAllocation.vue?vue&type=template&id=27cc2cc6"
import script from "./stockAllocation.vue?vue&type=script&lang=js"
export * from "./stockAllocation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__